import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './TemplateDetailBreadcrumb.styles'

interface TemplateDetailBreadcrumbProps {
  current: string
  onBackToSettings: () => void
}

/** Header title replacement: Funding request › {template name} — same font size. */
export const TemplateDetailBreadcrumb = ({
  current,
  onBackToSettings,
}: TemplateDetailBreadcrumbProps) => {
  const { classes } = useStyles()

  return (
    <span
      className={classes.breadcrumb}
      data-testid="template-settings-breadcrumb"
    >
      <button
        type="button"
        className={classes.link}
        onClick={onBackToSettings}
      >
        Funding request
      </button>
      <FontAwesomeIcon icon={faChevronRight} className={classes.separator} />
      <span
        className={classes.current}
        data-testid="template-breadcrumb-name"
        title={current}
      >
        {current}
      </span>
    </span>
  )
}

export default TemplateDetailBreadcrumb
